<template>

    <div class="summary-container m-b-10 m-t-20 p-20 card-border">
        <div class="flexed justify-center align-center" v-if="loading">
            <loading></loading>
        </div>
      <div v-else>
        <h4 class="m-t-0">{{ $t("lbl_activity_details") }}</h4>
        <div class="flexed justify-between remove-margin"><p>{{ $t("lbl_date") }}</p><p>{{ activityDetails.selectedDate | formatDate}}</p></div>
        <div class="flexed justify-between remove-margin"><p>{{ $t("lbl_capacity_left") }}</p><p>{{ priceDetails.capacity_left > 0 ? priceDetails.capacity_left : 0  }}</p></div>
        <div class="flexed justify-between remove-margin"><p>{{ $t("lbl_time") }}</p><p><span>{{ activityDetails.from_time | formatTime }}</span> - <span>{{ activityDetails.to_time | formatTime}}</span>  </p></div>
        <h4 class="m-t-20 m-b-0">{{ $t("lbl_select_number_of_guests") }}</h4>
        <div class="flexed justify-between align-center">

          <p>{{ $t("lbl_number_of_adults") }}</p>
          <el-input-number v-model="nrAdults"
                               :min="1"
                               :max="maxAdultsCapacity"
                               @keyup.native="onKeyUp"
                               @change="onChange()"
              ></el-input-number>
        </div>
        <div class="flexed justify-between align-center">
          <p>{{ $t("lbl_number_of_children") }}</p>
          <el-input-number v-model="nrChildren"
                               :min="0"
                               :max="maxChildrenCapacity"
                               @keyup.native="onKeyUp"
                               @change="onChange()"
              ></el-input-number>
        </div>


        <div class="rate-details p-t-20">
          <h4 class="m-b-0" >{{ $t("lbl_rate_details") }}</h4>
          <div class="charges-data">
            <div class="flexed justify-between base-price"><p>{{ $t("lbl_base_price") }}</p>
              <p>{{ priceDetails.base_price | currency(currency) }}</p>
            </div>
            <div class="flexed m-b-5">
              <span class="covers">{{ $t("lbl_covers") }} {{ priceDetails.base_price_adult_count }} {{ $t("lbl_adult_and") }} {{ priceDetails.base_price_children_count }} {{ $t("lbl_children") }}</span>
            </div>
            <div class="flexed m-b-5">
              <span class="covers">{{ $t("lbl_additional_adult_price") }} {{ priceDetails.additional_price_per_adult | currency(currency) }}</span>
            </div>
            <div class="flexed m-b-5">
              <span class="covers">{{ $t("lbl_additional_child_price") }} {{ priceDetails.additional_price_per_child | currency(currency) }}</span>
            </div>
            <div class="flexed justify-between bold"><p>{{ $t("lbl_total_amount") }}</p><p>{{ total | currency(currency)}}</p></div>
            <div class="flexed justify-between"><p>{{ $t("lbl_total_taxes") }}</p><p>{{priceDetails.total_taxes | currency(currency)}}</p></div>
            <div class="flexed justify-between bold grand-total"><p>{{ $t("lbl_grand_total") }}</p><p>{{ priceDetails.grand_total | currency(currency)}}</p></div>
          </div>
          <!-- <el-button type="primary" class="p-20 btn-proceed-booking">Proceed with Booking</el-button> -->
        </div>
      </div>
    </div>
</template>


<script>
  import loading from '@/components/common/loading.vue';
  import { mapMutations, mapState } from 'vuex';
  import apiCall from '@/services/activities/api-calls-activities.service'
  import CurrencyData from '@/assets/currencies/currencies';
export default {
    name: 'SummaryDetails',
    components: {loading},
    data() {
      return {
        loading: false,
        currencyData: CurrencyData,
        nrAdults: 1,
        nrChildren:0
      }
    },
    computed: {
      ...mapState({
        currency: state => state.activities.propertyDetails.currency,
        activityDetails: state => state.activities.activityDetails,
        priceDetails: state => state.activities?.priceDetails,
        property: state => state.activities.propertyDetails,
      }),
      maxAdultsCapacity() {
        return this.priceDetails?.capacity_left + this.nrAdults
      },
      maxChildrenCapacity() {
        return this.priceDetails?.capacity_left + this.nrChildren
      },
      disableIncrease() {
        return  this.priceDetails?.capacity_left === 0
      },
      total() {
        return this.priceDetails.total_charge_adult + this.priceDetails.total_charge_children + this.priceDetails.base_price
      },
      // totalAdditionalAdultsPrice() {
      //   return this.priceDetails.base_price_adult_count * this.priceDetails.additional_price_per_adult
      // },
      // totalAdditionalChildrenPrice() {
      //   return this.priceDetails.base_price_children_count * this.priceDetails.additional_price_per_child
      // }
    },
    methods: {
      ...mapMutations({
        SET_PRICE_DETAILS: 'activities/SET_PRICE_DETAILS'
      }),
      onChange(){
        const payload = {
          adults: this.nrAdults,
          children: this.nrChildren
        }
        this.getPriceDetails(payload)
      },
      async getPriceDetails(payload) {
        this.loading = true;
        try{
          let response = await apiCall.get(`${this.property.id}/web/activity-instances/${this.activityDetails.id}/calculate-price`,
           payload, 'eventManagementApi')


          console.log(response.data);
          this.SET_PRICE_DETAILS(response.data)

        }
        catch(error){
          console.log(error)
        }
        this.loading = false;
      },
    },
    beforeMount(){
      const payload = {
          adults: this.nrAdults,
          children: this.nrChildren
        }
      this.getPriceDetails(payload);
      console.log(this.priceDetails)
    }
}
</script>


<style lang="scss" scoped>
@import "~css_vars";
@import '~mixins';

.grid-container {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 10px;

  .grid-item {
    background-color: #ccc;
  }

  .grid-item-1 {
    grid-row: 1 / 3;
  }
}

.text-container {
  .points {
    margin-left: 24px;
    list-style: disc;
  }
}

.remove-margin p{
  margin: 4px 0;
}

.btn-proceed-booking {
  width: 100%;
  font-weight: bold;
}

.charges-data p {
  margin: 10px 0;
}

.summary-container{
  width: 35%;
}

.img-size {
  max-width: 100%;
}
  .large-image {
    grid-row: 1 / 3;
    width: 100%;
  }

  .covers {
    font-size: 14px;
    color: #adb5bd;
  }

  .aditional {
    margin-top: 10px;
  }

  .aditional p{
    margin: 0;
  }

  .select-time {
    margin: 0;
  }

  .base-price p{
    margin-top: 10px;
    margin-bottom: 0px;
  }

  .additinal-calculations {
    font-size: 14px;
    color: #adb5bd;
  }

  @include media("<=tablet") {
    .summary-container{
      width: 100%;
    }

    .el-input-number {
      width: 130px;
    }

    .grand-total {
      padding-bottom: 20px;
    }
  }

</style>
